<template>
  <div class="entrance">
    <div :class="['entrance-background', willEnter]">
      <div class="svgs">
        <svg width="1076" height="716" viewBox="0 0 1076 716" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="1" y="1" width="1074" height="714" rx="6" stroke="#B4B4B4"/>
        </svg>
        <svg width="1076" height="716" viewBox="0 0 1076 716" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect class="border" x="1" y="1" width="1074" height="714" rx="6" stroke="#B4B4B4"/>
        </svg>
      </div>
    </div>
    <div class="entrance-details">
      <!-- <p class="trustName">{{ $store.state.org.name }}<br>Concept Trust</p> -->
      <p class="trustName">Concept Trust</p>
      <button class="shadow wallet-connect" @click="connectWallet" v-if="!$store.state.walletConnect.user.address && $store.state.walletConnect.loadingWallet == null && noGroupAvailable == false">Enter with Wallet</button>
      <div v-if="isDesktop">
        <button class="wallet-connect link-button" @click="connectWallet('mobile')" v-if="!$store.state.walletConnect.user.address && $store.state.walletConnect.loadingWallet == null && noGroupAvailable == false">or Use Mobile</button>
      </div>
      <p v-if="noGroupAvailable">Welcome! Please go directly to your groups URL to enter.</p>
      <p class="loadingMessage" v-if="$store.state.walletConnect.loadingWallet == 'loading'">Connecting...</p>
      <p class="loadingMessage" v-if="$store.state.walletConnect.loadingWallet == 'signing'"><b>Sign to Verify</b><br>Check your wallet for<br>a message to sign.</p>
      <p class="loadingMessage" v-if="$store.state.walletConnect.loadingWallet == 'verifying'">Verifying...</p>
      <p class="loadingMessage" v-if="$store.state.walletConnect.shouldAllow">Welcome back!</p>
      <br>
      <p v-if="$store.state.walletConnect.allowMessage">{{ $store.state.walletConnect.allowMessage }}</p>
      <button v-if="$store.state.walletConnect.allowMessage && $store.state.walletConnect.user.address" @click="disconnectWallet">Disconnect Wallet</button>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Entrance',
  components: {

  },
  data() {
    return {
      noGroupAvailable: false,
    }
  },
  computed: {
    willEnter() {
      if(this.$store.state.walletConnect.shouldAllow == true) {
        console.log('will entterrr')
        return 'will-enter';
      } else {
        return '';
      }
    },
    isDesktop(){
      const userAgent = window.navigator.userAgent;
      const platforms = ['Macintosh', 'Windows', 'Linux']; // add all platforms you consider as "desktop"
      return platforms.some((platform) => userAgent.includes(platform));
    },
  },
  mounted() {
    this.$store.commit('setShowNewBlockInHeader', { newValue: false });

    this.checkForRedirect();

    // For building with svgs:
    //
    // let svgEl = document.querySelector('svg rect');
    // console.log(svgEl)
    // console.log(svgEl.getTotalLength())
    //
    // console.log('current walletConnect state: ', this.$store.state.walletConnect)
  },
  methods: {
     connectWallet(preference = 'mobile'){
      if(!this.isDesktop || preference == 'mobile'){
        this.$store.dispatch('connectWallet')
      } else {
        this.$store.dispatch('connectWalletMetamask')
      }
     },
     disconnectWallet(){
       this.$store.dispatch('disconnectWallet')
     },
     checkForRedirect(){
       try {
         let redirect = this.$router.currentRoute.value.query.to ? this.$router.currentRoute.value.query.to : undefined;
         let activeTrust = redirect.split('/')[1];
         // console.log('checkForRedirect', redirect, activeTrust)
         if(activeTrust == '' || activeTrust == undefined){
           this.noGroupAvailable = true;
         }
       } catch (e) {
         this.noGroupAvailable = true;
       }
     }
  },
}

</script>

<style>
  .entrance {
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    height: 100vh;
    justify-content: center;
  }

  .entrance-background {
    padding: 60px;
    width: 100vw;
    height: 100vh;
    box-sizing: border-box;
    position: absolute;
    /* transform: translateY(-60px); */
    pointer-events: none;
  }

  .entrance-background .svgs {
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .entrance-background svg {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
  }

  .entrance-background.will-enter svg .border {
    --length: 3564.73779296875;
    /* stroke-dasharray: var(--length);
    stroke-dashoffset: var(--length); */
    animation: animateFromCenterTop 3000ms ease-in-out forwards;
    stroke: black;
  }

  @keyframes animateBorder {
    to {
      stroke-dashoffset: 0;
      stroke-width: 1px;
    }
  }

  @keyframes animateFromCenterTop {
      from {
          stroke-dasharray: 0 3564.73779296875;
          stroke-dashoffset: calc(1782.36 + 1250);
      }
      to {
          stroke-dasharray: 3564.73779296875 0;
          stroke-dashoffset: calc(3564.73779296875 + 1250);
      }
  }

  .entrance-details {

  }

  .loadingMessage {
    padding: 10px 30px;
    background: var(--beige-600);
    border-radius: 10px;
  }

  .loadingMessage b {
    font-weight: 500;
  }

  button.link-button {
    background: none;
    color: var(--beige-800);
    margin-top: 1rem;
  }

</style>
